export const stepwizarddata = [
    {
        id:'step-1',
        num:1
    },
    {
        id:'step-2',
        num:2
    },
    {
        id:'step-3',
        num:3
    },
    {
        id:'step-4',
        num:4
    }
]